import React, { useState } from 'react'
import SideBar from '../components/SideBar'
import DetailsHeaderBar from '../components/DetailsHeaderBar'
import DetailSection from '../components/DetailSection'
import { FaRegUserCircle } from 'react-icons/fa'
import { useLocation, useNavigate } from 'react-router-dom'
import { MdOutlineImage } from "react-icons/md";
import { GiPriceTag } from "react-icons/gi";
import { MdOutlineInventory2 } from "react-icons/md";
import { MdOutlineEditAttributes } from "react-icons/md";
import { MdProductionQuantityLimits } from "react-icons/md";


function ProductDetails() {

    const location = useLocation();
    const product = location.state?.product;
    const navigate = useNavigate();

    const [previewImage, setPreviewImage] = useState(null);

    const goToEdit = () => {
        navigate("/product-edit", { state: { product } });
    };

    const normalizeUrl = (src) => {
        if (!src) return null;
        if (typeof src !== "string") return null;
        const localhostNoPort = /^http:\/\/localhost(?!:)/i;
        if (src.startsWith("http://") || src.startsWith("https://")) {
            return src.replace(localhostNoPort, "https://api.topcoinuk.com");
        }
        if (src.startsWith("blob:") || src.startsWith("data:")) return src;
        const base = "https://api.topcoinuk.com";
        if (src.startsWith("/")) return `${base}${src}`;
        return `${base}/${src}`;
    };

    const getThumbnailSrc = () => {
        if (!product) return "/no-image.png";
        const thumb = product.thumbnail_full_url || product.thumbnail_url || product.thumbnail;
        if (thumb && typeof thumb === "object" && thumb.preview) return thumb.preview;
        const normalized = normalizeUrl(thumb);
        return normalized || "/no-image.png";
    };

    const getProductImages = () => {
        const raw = product?.image_full_urls || product?.image_urls || product?.images;
        if (!raw) return [];

        const ensureArray = (val) => {
            if (Array.isArray(val)) return val;
            if (typeof val === "string") {
                try {
                    const parsed = JSON.parse(val);
                    return Array.isArray(parsed) ? parsed : [];
                } catch {
                    return [];
                }
            }
            return [];
        };

        return ensureArray(raw)
            .map((img) => {
                if (typeof img === "string") return normalizeUrl(img);
                if (typeof img === "object" && img?.preview) return img.preview;
                if (typeof img === "object" && img?.url) return normalizeUrl(img.url);
                return null;
            })
            .filter(Boolean);
    };

    const displayVal = (val, fallback = "-") => {
        if (val === undefined || val === null || val === "") return fallback;
        if (Array.isArray(val)) return val.join(", ");
        if (typeof val === "object") return val.label || val.name || val.retail_name || val.value || fallback;
        return val;
    };

  return (
    <div className="manage-member-layout">
        <SideBar />
        <div className="product-details-main">
            <DetailsHeaderBar
                title="Product Details"
                subtitle="You can edit the product details to update the product details"
                breadcrumbs={[
                    {label: "Home", path: "/manage-member"},
                    {label: "Manage Product", path: "/manage-product"},
                    {label: "Product Details" }
                ]}
            />

            <DetailSection
                title="Product Image"
                icon={MdOutlineImage}
                showEdit={true}
                onEdit={goToEdit}
                fields={[
                    {
                        label: "Thumbnail",
                        value: product.thumbnail ? (
                            <div style={{ marginTop: 6 }}>
                            <img
                                src={getThumbnailSrc()}
                                alt={product.name}
                                onClick={() => setPreviewImage(getThumbnailSrc())}
                                style={{
                                // width: 140,
                                height: 140,
                                objectFit: "cover",
                                borderRadius: 8,
                                border: "1px solid #ddd",
                                cursor: "pointer",
                                }}
                            />
                            </div>
                        ) : "No thumbnail",
                    },

                    {
                        label: "Images",
                        value: getProductImages().length > 0 ? (
                            <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
                            {getProductImages().map((src, index) => (
                                <img
                                key={index}
                                src={src}
                                alt={`Product ${index}`}
                                onClick={() => setPreviewImage(src)}
                                style={{
                                    // width: 120,
                                    height: 90,
                                    objectFit: "cover",
                                    borderRadius: 6,
                                    border: "1px solid #ddd",
                                    cursor: "pointer",
                                }}
                                />
                            ))}
                            </div>
                        ) : (
                            "No Images"
                        ),
                    }
                ]}
            />

            <DetailSection
                title="Basic Details"
                icon={MdProductionQuantityLimits}
                showEdit={false}
                // onEdit={goToEdit}
                fields={[
                    { label: "Name", value: displayVal(product.name) },
                    { label: "Slug", value: displayVal(product.slug) },
                    { label: "SKU", value: displayVal(product.sku) },
                    { label: "Category", value: displayVal(product.category?.name || product.category) },
                    { label: "Subcategory", value: displayVal(product.subcategory?.name || product.subcategory) },
                    { label: "Supplier", value: displayVal(product.supplier) },
                    // { label: "Product seller", value: displayVal(product.seller) },
                    { label: "Featured", value: product.featured ? "Yes" : "No" },
                    { label: "Status", value: displayVal(product.status) },
                    { label: "Visibility", value: displayVal(product.visibility) }
                ]}
            />
            <DetailSection
                title="Pricing, Tax and Commission"
                icon={GiPriceTag}
                showEdit={false}
                // onEdit={goToEdit}
                fields={[
                    { label: "Price", value: displayVal(product.price) },
                    { label: "Compare price", value: displayVal(product.compare_price) },
                    { label: "Cost", value: displayVal(product.cost_per_item) },
                    { label: "Product discount", value: displayVal(product.product_discount) },
                    { label: "Tax", value: displayVal(product.tax) },
                    { label: "Commission", value: displayVal(product.commission) }
                ]}
            />
            <DetailSection
                title="Inventory"
                icon={MdOutlineInventory2}
                showEdit={false}
                // onEdit={goToEdit}
                fields={[
                    { label: "Track quantity", value: product.track_quantity ? "Yes" : "No" },
                    { label: "Stock quantity", value: displayVal(product.stock_quantity) },
                    { label: "Stock", value: displayVal(product.stock) },
                    { label: "Weight", value: displayVal(product.weight) }
                ]}
            />
            <DetailSection
                title="Description and Attributes"
                icon={MdOutlineEditAttributes}
                showEdit={false}
                // onEdit={goToEdit}
                fields={[
                    { label: "Full description", value: displayVal(product.description) },
                    { label: "Short description", value: displayVal(product.short_description) },
                    { label: "Attibutes", 
                      value: product.attributes && Object.keys(product.attributes).length > 0
                        ? Object.entries(product.attributes)
                            .map(([key, value]) => `${key}: ${value}`)
                            .join(" | ")
                        : "-"
                    },
                    { label: "Tags", value: displayVal(product.tags) },
                    { label: "Meta title", value: displayVal(product.meta_title) },
                    { label: "Meta description", value: displayVal(product.meta_description) },
                    { label: "Meta keywords", value: displayVal(product.meta_keywords) },
                ]}
            />
        </div>
        {previewImage && (
              <div
                onClick={() => setPreviewImage(null)}
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0,0,0,0.8)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999,
                }}
              >
                <div style={{ position: "relative" }}>
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      maxWidth: "90vw",
                      maxHeight: "90vh",
                      borderRadius: 10,
                    }}
                  />

                  <button
                    onClick={() => setPreviewImage(null)}
                    style={{
                      position: "absolute",
                      top: -10,
                      right: -10,
                      background: "#e53935",
                      color: "#fff",
                      border: "none",
                      borderRadius: "50%",
                      width: 30,
                      height: 30,
                      cursor: "pointer",
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    ✕
                  </button>
                </div>
              </div>
            )}
    </div>
  )
}

export default ProductDetails